import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import { entityJurisdictionsRequest } from '@store/manageUsers/entityJurisdictions';
import {
  accessEntitiesRequest,
  permissionsRequest,
  permissionsUpdateRequest,
} from '@store/manageUsers/permissions';
import { rolesRequest } from '@store/manageUsers/roles';
import { userRequest, userUpdateRequest, userUpdateRoleRequest } from '@store/manageUsers/user';

export default all([
  // @ts-expect-error: Will be an issue until handle request is converted to TS
  takeLatest(userRequest.type, handleRequest),
  // @ts-expect-error: Will be an issue until handle request is converted to TS
  takeEvery(userUpdateRequest.type, handleRequest),
  // @ts-expect-error: Will be an issue until handle request is converted to TS
  takeEvery(userUpdateRoleRequest.type, handleRequest),
  // @ts-expect-error: Will be an issue until handle request is converted to TS
  takeLatest(rolesRequest.type, handleRequest),
  // @ts-expect-error: Will be an issue until handle request is converted to TS
  takeLatest(permissionsRequest.type, handleRequest),
  // @ts-expect-error: Will be an issue until handle request is converted to TS
  takeEvery(permissionsUpdateRequest.type, handleRequest),
  // @ts-expect-error: Will be an issue until handle request is converted to TS
  takeLatest(entityJurisdictionsRequest.type, handleRequest),
  // @ts-expect-error: Will be an issue until handle request is converted to TS
  takeLatest(accessEntitiesRequest.type, handleRequest),
]);
